import Captcha from '../class/Captcha';
import Form from '../class/Form';
import { post } from '../utils/functions';

export default class SellsyForm {
	constructor() {
		const sections = document.querySelectorAll('.sellsy-form');
		sections.forEach((section) => new Section(section));
	}
}

class Section {
	constructor(section) {
		this.section = section;

		this.form = new Form(this.section.querySelector('form'), {
			onSubmit: this.onSubmit.bind(this),
		});
	}
	onSubmit() {
		this.form.submitButton.load();

		Captcha.submit()
			.then(() => {
				post(
					{
						action: 'submit_sellsy_form',
						form: this.form.el,
					},
					(res) => {
						const response = typeof res === 'string' ? JSON.parse(res) : res;
						this.form.submitButton.reset();

						if (response && response.success) {
							const downloadWrapper = document.createElement('div');
							downloadWrapper.classList.add('button-wrapper');

							const download = document.createElement('a');

							// download.style.display = 'none';
							download.classList.add('cta', 'cta--light-blue');
							download.setAttribute('href', response.data.file);
							download.setAttribute('download', response.data.filename);
							download.setAttribute('target', '_blank');
							download.setAttribute('data-no-swup', true);
							download.innerText = response.data.label;
							download.style.marginTop = '30px';

							this.form.replace(response.data.thank_you);

							downloadWrapper.appendChild(download);
							this.section.appendChild(downloadWrapper);

							download.click();
						}
					},
					true
				);
			})
			.catch(() => {
				this.form.submitButton.reset();
			});
	}
}
